import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'searchfilter' })
export class FilterPipe implements PipeTransform 
{
  transform(items: any[], filter: string, roteirosDoDia: boolean): any 
  {
    if (roteirosDoDia) {
      // Selecionar apenas os itens com roteiros para o dia de hoje
      const date = new Date(); 
      date.setHours(0, 0, 0, 0);
      items = items.filter(item => { 
        let dateItem = new Date(item.PrevisaoSaida);
        dateItem.setHours(0, 0, 0, 0);
        return dateItem.toString() === date.toString();
      });
    }

    if (!items || !filter) {
      return items;
    }

    filter = filter.toLowerCase();

    return items.filter(item => {
      // Verificar se o filtro corresponde a `NumeroPedido` ou qualquer outro campo
      const numeroPedidoMatch = item.pedidos?.NumeroPedido?.toLowerCase().includes(filter);
      const generalMatch = JSON.stringify(item).toLowerCase().includes(filter);
      
      return numeroPedidoMatch || generalMatch;
    });
  }
}